import { Routes } from '@angular/router';
import { AccountModule } from 'app/pages/account/account.module';

// Route for content layout without sidebar, navbar and footer for pages like Login, Registration etc...

export const ContentLayoutRoutes: Routes = [
  {
    path: 'account',
    loadChildren: () => AccountModule
  }
];
